import * as localDateAction from '../actions/localDate.action';
import { createReducer, on } from '@ngrx/store';

export interface LocalDateState {
  date: string;
  loaded: boolean;
  loading: boolean;
}

export const initialState: LocalDateState = {
  date: null,
  loaded: false,
  loading: false
};

const localDateReducer = createReducer(
  initialState,
  on(localDateAction.getLocalDateSuccess, (state, payload) => {
    const date = payload.localDate;
    return { date, loaded: true, loading: false };
  })
);

export function reducer(state, action) {
  return localDateReducer(state, action);
}
